import { IssueTypeActionTypes } from "./constants";

const INIT_STATE = {
    issueTypeList: [],
    loading: true,
    updated: null,
    error: null,
    instant: null,
};

const IssueType = (state = INIT_STATE, action) => {
    switch(action.type) {
        case IssueTypeActionTypes.API_RESPONSE_SUCCESS:
            switch(action.payload.actionType) {
                case IssueTypeActionTypes.GET_ISSUE_TYPE_LIST: {
                    return {
                        ...state,
                        issueTypeList: action.payload.data.data,
                        totalData: action.payload.data.total,
                        loading: false,
                    };
                }
                case IssueTypeActionTypes.GET_ISSUE_TYPE_ID: {
                    return {
                        ...state,
                        issueType: action.payload.data.data,
                        loading: false,
                    };
                }
                case IssueTypeActionTypes.ADD_ISSUE_TYPE: {
                    const response = { id: action.payload.data.data.issue_type_id, message: action.payload.data.message };
                    return {
                        ...state,
                        updated: response,
                        loading: false,
                    }
                }
                case IssueTypeActionTypes.ADD_ISSUE_TYPE_INSTANT:
                    const newIssueTypeData = {
                        issue_type_id: action.payload.data.data.issue_type_id,
                        issue_name: state.instant.description,
                        message: action.payload.data.message,
                    }

                    const newTotalData = state.totalData + 1
                    const response = { id: action.payload.data.data.issue_type_id, message: action.payload.data.message };
                // eslint-disable-next-line no-lone-blocks
                {
                    return {
                        ...state,
                        issueTypeList: [newIssueTypeData, ...state.issueTypeList],
                        totalData: newTotalData,
                        instant: newIssueTypeData,
                        loading: false,
                    };
                }
                case IssueTypeActionTypes.UPDATE_ISSUE_TYPE: {
                    const response = {
                        id: action.payload.data.data.issue_type_id,
                        issue_name: action.payload.data.data.issue_name,
                        description: action.payload.data?.data?.description,
                        message: action.payload.data.message,
                    }
                    // eslint-disabled-next-line no-lone-blocks
                    return {
                        ...state,
                        loading: false,
                        updated: response,
                    };
                }
                case IssueTypeActionTypes.DELETE_ISSUE_TYPE: {
                    const response = { deleted: action.payload.data.data.deleted, message: action.payload.data.message }
                    return {
                        ...state,
                        loading: false,
                        updated: response
                    };
                }
                default:
                    return { ...state };
            }
        
        case IssueTypeActionTypes.API_RESPONSE_ERROR:
            switch(action.payload.actionType) {
                case IssueTypeActionTypes.GET_ISSUE_TYPE_LIST: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                    };
                }
                case IssueTypeActionTypes.GET_ISSUE_TYPE_ID: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false
                    }
                }
                case IssueTypeActionTypes.ADD_ISSUE_TYPE: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                    }
                }
                case IssueTypeActionTypes.ADD_ISSUE_TYPE_INSTANT: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                    }
                }
                case IssueTypeActionTypes.UPDATE_ISSUE_TYPE: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                    }
                }
                case IssueTypeActionTypes.DELETE_ISSUE_TYPE: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                    }
                }
                default:
                    return { ...state };
            }
        
        case IssueTypeActionTypes.ADD_ISSUE_TYPE_INSTANT:
            return { ...state, instant: action.payload }
        case IssueTypeActionTypes.RESET_ISSUE_TYPE_UPDATE:
            return { ...state, issueType: null, updated: null, error: null, instant: null }
        case IssueTypeActionTypes.RESET_ISSUE_TYPE:
            return { ...state, issueType: null, updated: null, error: null, instant: null }
        
        default:
            return { ...state }
    }
};

export default IssueType;